

export const aiToolTemplate = {
    backToWorkbench: 'Back to Workbench',
    uploadImage: 'Upload Image',
    uploadImageDescription: 'Support JPG, PNG formats, max 10MB',
    clickOrDragUpload: 'Click or drag to upload image',
    uploadSuggestion: 'Recommend using clear images for best results',
    
    // Text-to-image related
    enterPrompt: 'Enter Prompt',
    enterPromptDescription: 'Please enter a prompt describing the image you want to generate',
    promptPlaceholder: 'Please enter a description of the image you want to generate...',
    enterPromptFirst: 'Please enter a prompt first',

    supplementaryPrompt: 'Supplementary Prompt',
    supplementaryPromptDescription: 'Add extra description to fine-tune the result (optional)',
    enterSupplementaryPrompt: 'Enter supplementary prompt...',
    
    generationResult: 'Generation Result',
    resultCompleted: 'Your {toolName} has been generated',
    resultWaiting: 'Upload an image and click generate to start creating',
    waitingGeneration: 'Waiting for Generation',
    waitingDescription: 'After uploading an image, the generated {toolName} will be displayed here',
    startGeneration: 'Start Generation',
    generating: 'Generating',
    downloadImage: 'Download Image',
    downloadAllImages: 'Download All Images',
    downloadStarted: 'Download started',
    downloadFailed: 'Download failed, please try again later',
    generationFailed: 'Generation failed, please try again later',
    // New hardcoded text translations
    uploadImageFirst: 'Please upload an image first',
    generationStarted: 'Image generation started, please wait...',
    generationSuccess: 'Image generated successfully!',
    promptRequired: 'Please enter a prompt',
    generationTimeout: 'Generation timeout, please try again later',
    generationStatusError: 'Generation status error',
    pollStatusFailed: 'Failed to query generation status',
    generationStatusAbnormal: 'Generation status abnormal',
    
    // SizeSelector component translations
    generationSettings: 'Generation Settings',
    model: 'Model',
    aspectRatio: 'Aspect Ratio',
    resolution: 'Resolution',
    // PromptInput component translations
    promptInput: {
      defaultTitle: 'Enter Prompt',
      defaultPlaceholder: 'Please enter your prompt...',
      validation: {
        required: 'This field is required',
        minLength: 'At least {min} characters required',
        maxLength: 'Cannot exceed {max} characters',
        pattern: 'Invalid input format'
      },
      suggestions: {
        toggle: 'View Prompt Suggestions',
        title: 'Prompt Suggestions'
      }
    },
    
    // ImageUpload component translations
    imageUpload: {
      defaultTitle: 'Upload Image',
      defaultDescription: 'Support JPG, PNG, GIF formats, max 10MB',
      referenceTitle: 'Upload Reference Image',
      referenceDescription: 'Upload a reference image to guide the logo design style',
      referencePlaceholder: 'Click to upload reference image',
      dragDropText: 'Drag images here, or',
      clickToUpload: 'Click to Upload',
      uploading: 'Uploading...',
      addMore: 'Add More Images',
      removeImage: 'Remove Image',
      validation: {
        required: 'Please upload at least one image',
        fileSize: 'File size cannot exceed {maxSize}MB',
        fileType: 'Unsupported file format, please upload {allowedTypes}',
        maxFiles: 'Maximum {max} images allowed',
        uploadFailed: 'Upload failed, please try again'
      }
    },
    
    // ColorPicker component translations
    colorPicker: {
      defaultTitle: 'Select Color',
      defaultDescription: 'Choose a background color or enter a custom color value',
      currentColor: 'Current Color',
      noColorSelected: 'No color selected',
      showPalette: 'Show Palette',
      hidePalette: 'Hide Palette',
      presetColors: 'Preset Colors',
      customColor: 'Custom Color',
      colorInput: 'Color Value',
      clearColor: 'Clear Color',
      selectedColor: 'Selected Color',
      none: 'None',
      hexPlaceholder: 'Enter hex color value',
      validation: {
        required: 'Please select a color',
        invalidFormat: 'Invalid color format, please use #RRGGBB format'
      }
    },

    placePicker: {
      validation: {
        required: 'Please select a location'
      }
    },
    
    // Error messages
    fileTooLarge: 'File size cannot exceed 10MB',
    invalidFileType: 'Please upload JPG, PNG or GIF format images',
    uploadFailed: 'Upload failed, please try again',
    networkError: 'Network error, please check your connection',
    serverError: 'Server error, please try again later',
    // Tool names and descriptions
    tools: {
      watercolor: {
        name: 'Watercolor Style',
        description: 'Transform your image into a soft, transparent watercolor painting with dreamy, romantic visual effects'
      },
      sketch: {
        name: 'Sketch Style',
        description: 'Convert your image into an exquisite sketch artwork, showcasing the power and beauty of lines'
      },
      cyberpunk: {
        name: 'Cyberpunk Style',
        description: 'Transform your image into a futuristic cyberpunk art style with cool sci-fi atmosphere'
      },
      popArt: {
        name: 'Pop Art Portrait',
        description: 'Transform your portrait into vibrant and bold pop art style, showcasing the charm of modern art'
      },
      anime: {
        name: 'Anime Style Conversion',
        description: 'Convert your image into beautiful anime style and experience the charm of the 2D world'
      },
      faceSwap: {
        name: 'AI Face Pinch',
        description: 'Upload a photo with a face to generate avatars in different styles'
      },
      oilPainting: {
        name: 'Oil Painting Style',
        description: 'Transform your image into a classic oil painting artwork, showcasing the rich texture of traditional painting'
      },
      professionalPortrait: {
        name: 'Professional Portrait',
        description: 'Create professional business headshots',
        clothingStyle: 'Clothing Style',
        clothingStyleDesc: 'Select the professional attire for the portrait',
        styles: {
          default: 'Default (Dark Business Suit)',
          darkSuit: 'Dark Business Suit',
          lightSuit: 'Light Business Suit',
          shirt: 'Business Shirt',
          casual: 'Business Casual',
          tuxedo: 'Tuxedo',
          polo: 'Polo Shirt',
          dress: 'Professional Dress',
          blazer: 'Blazer & T-Shirt'
        }
      },
      idPhotoGeneration: {
        name: 'ID Photo Generation',
        description: 'Transform your photo into standard ID photos with support for multiple sizes and background colors'
      },
      photoRestoration: {
        name: 'Photo Restoration',
        description: 'Restore old, damaged, or faded photos by removing scratches, stains, and imperfections to recover original clarity and colors',
      },
      emojiPack: {
        name: 'Emoji Pack Generator',
        description: 'Upload one clear portrait photo and generate a cohesive set of emojis with multiple expressions and actions, suitable for chat and social platforms'
      }
    }
  };
